import { FC } from "react";

const ProgressBar: FC<ProgressBarProps> = ({
  progress,
  width = "w-[280px]",
  height = "h-1",
  bgColor = "bg-[#E8E8E8]",
  progressColor = "bg-black",
}) => {
  return (
    <div
      className={`${width} ${height} ${bgColor} rounded-full overflow-hidden`}
    >
      <div
        className={`h-full ${progressColor} rounded-full transition-all duration-500 ease-in-out`}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ProgressBar;

type ProgressBarProps = {
  progress: number; // Progress value (0 to 100)
  width?: string; // Optional width (e.g., w-full)
  height?: string; // Optional height (e.g., 'h-4')
  bgColor?: string; // Optional background color
  progressColor?: string; // Optional progress bar color
};
